'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function Walkthrough() {
  this.id = null;
  this.node = null;
  this.extends = [];

  this.contentType = 'walkthroughGallery';
  this.contentId = ''; // contentId defined in pug file

  this.slidesRef = null;
  this.slidesElement = null;

  this.slideSetProduct = null;
  this.slidesProductArray = [];
  this._currentSlideProduct = null;
  this.linkCallbacks = []; // callbacks on links from descriptions. Should be implemented at component level. Potentially there could be multiple description having links, therefore the array index should match the slide index.
  this.waitlistActionPayload = null; // override at component level.
  this.isWaitlisted = null; // override at component level.
  this.analyticsCallbacks = {
    waitlistSuccess: null // analytics success event for soa request, implement at product level (e.g. "bump me up" for Spend)
  };
  this.legalDisclaimersEnabled = true; // Parse slides for legal disclaimers

  this.initWalkthrough = function () {
    this._portalPresenter = document.getElementById('Portal').mogo();
    this.slidesRef = 'content.' + this.contentType + '.' + this.contentId + '.walkthroughSet';
    this.slidesElement = this.node.querySelector('.js--mUp-walkthrough-slides');
    this.prevBtnElement = this.node.querySelector('.js--swiper-prev-btn');
    this.nextBtnElement = this.node.querySelector('.js--swiper-next-btn');

    this._product = new Product(this.slidesRef, this.presenter);
    this.analytics.pushEvent('virtual-page-view');
    this._product.pushContentfulAnalyticsEvent();
    this.node.removeClass('hide');
    if (this.legalDisclaimersEnabled) {
      this._setupDisclaimers(); // init legal disclaimers popup
    }
    this.slidesElement.addClass('swiper-container');
    this._populateSlides();
    this._setupNavEventListener();
    if (this.legalDisclaimersEnabled) {
      this._setupDisclaimersEventListener();
    }
    this._onSlideNav();
    this._portalPresenter.scanNodeForClickAnalytics(this.node); // scan DAI for dynamically created elements
    // Required when route has defer_page_load_completed: true
    this._portalPresenter.setPageLoadComplete();
  };

  this._populateSlides = function () {
    var _this = this;

    var slidesArray = this.presenter.getModelProperty(this.slidesRef + '.walkthroughScreens');
    var slidesContainer = this.slidesElement.querySelector('ul');
    slidesArray.forEach(function (slide, index) {
      _this.slidesProductArray.push(new Product(_this.slidesRef + '.walkthroughScreens[' + index + ']', _this.presenter));
      var slideElement = document.createElement('li');
      var mediaElement = document.createElement('div');
      var titleElement = document.createElement('h1');
      var descElement = document.createElement('p');
      slideElement.addClass('swiper-slide');
      mediaElement.addClass('mUP-walkthrough__media');
      titleElement.addClass('mUP-walkthrough__title');
      descElement.addClass('mUP-walkthrough__description');
      _this.slidesProductArray[index].loadMedia(mediaElement, { autoplay: false });
      _this.slidesProductArray[index].loadHTML(titleElement, 'headline');
      _this.slidesProductArray[index].loadHTML(descElement, 'description');

      // parse article content for any links
      var contentLinks = descElement.querySelectorAll('a');
      if (contentLinks.length > 0) {
        contentLinks.forEach(function (element) {
          return _this.slidesProductArray[index].setupLinkAction(element, element.getAttribute('href'), _this.linkCallbacks[index]);
        });
      }

      slideElement.appendChild(mediaElement);
      slideElement.appendChild(titleElement);
      slideElement.appendChild(descElement);
      _this._setupBtn(slideElement, _this.slidesProductArray[index]);
      slidesContainer.appendChild(slideElement);
      // setup analytics for individual slide
      var pageName = titleElement.textContent.toLowerCase().replace(/[^a-zA-Z0-9 ]/g, '').replace(/ /g, '-');
      slideElement.setAttribute('data-pagename', pageName);
    });
    this.slidesElement.mogo().initSwiper();
  };

  this._setupNavEventListener = function () {
    this.slidesElement.mogo()._slider.on('slideChangeTransitionEnd', this._onSlideNav.bind(this));
  };

  this._setupBtn = function (slideElement, slideProduct) {
    var _this2 = this;

    if (!slideProduct._contentModel.primaryCta && !slideProduct._contentModel.waitlist) {
      return;
    }
    // create cta
    var ctaContainer = document.createElement('div');
    var cta = document.createElement('button');
    var label = document.createElement('span');
    ctaContainer.addClass('mUP-walkthrough__cta');
    ctaContainer.addClass('js--waitlist-cta');
    cta.addClass('btn');
    cta.addClass('secondary');
    cta.addClass('invert');
    label.addClass('label');
    cta.appendChild(label);
    ctaContainer.appendChild(cta);
    slideElement.appendChild(ctaContainer);

    if (slideProduct._contentModel.primaryCta) {
      // setup navigation cta
      slideProduct.loadPrimaryCta(ctaContainer, 'nav-action-1');
    } else if (slideProduct._contentModel.waitlist) {
      // setup soa action cta
      // create message
      var msg = document.createElement('p');
      msg.addClass('mUP-walkthrough__msg');
      msg.addClass('js--waitlist-success');
      slideElement.appendChild(msg);
      slideProduct.loadWaitlist(slideElement, 'soa-action-1', 'account', this.waitlistActionPayload, this.isWaitlisted, function (data, res) {
        if (res === 200 && _this2.analyticsCallbacks.waitlistSuccess) {
          _this2.analyticsCallbacks.waitlistSuccess();
        }
      });
    }
  };

  this._onSlideNav = function () {
    if (this._currentSlideProduct && this._currentSlideProduct.animation) {
      this._currentSlideProduct.animation.stop();
    }
    if (this.legalDisclaimersEnabled) {
      this._updateDisclaimers();
    }
    this._currentSlideProduct = this.slidesProductArray[this.slidesElement.mogo()._currentSlide];
    if (this._currentSlideProduct.animation) {
      this._currentSlideProduct.animation.play();
    }
  };

  this._setupDisclaimers = function () {
    this.disclaimersDialog = document.getElementsByClassName('js--legal-disclaimers-popup')[0];
    this.legalContent = document.getElementsByClassName('js--legal-disclaimer')[0];
    var activeSlide = document.getElementsByClassName('swiper-slide-active')[0];
    if (this.legalContent.mogo && this.legalContent.mogo().create) {
      this.legalContent.mogo().create('LegalDisclaimer', {
        legal: $('.swiper-slide-active [data-legal]:visible', activeSlide), // element to look for sup tags in (note this is used later when redraw is called as well)
        presenter: this.presenter
      });
    }
  };

  this._setupDisclaimersEventListener = function () {
    var _this3 = this;

    var supElements = [].concat(_toConsumableArray(this.slidesElement.querySelectorAll('sup[data-legal]')));
    supElements.forEach(function (element) {
      return element.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        _this3.disclaimersDialog.mogo().show();
      });
    });
  };

  this._updateDisclaimers = function () {
    if (this.legalContent.mogo && this.legalContent.mogo().redraw) {
      this.legalContent.mogo().redraw();
    }
  };

  this.destroyWalkthrough = function () {
    if (this._product) {
      this._product.destroy();
    }
    if (this.disclaimersDialog) {
      this.disclaimersDialog.mogo().destroy();
    }
  };

  // Template file is not first component extended so don't use these
  this.init = function () {};
  this.initAllReady = function () {};
  this.destroy = function () {};
}